<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part"><a id="page_19"></a>P<span class="small">ART</span> I</h2>
<h2 class="part1">R<span class="small">OME</span>: T<span class="small">HE</span> L<span class="small">OCAL AND THE</span> G<span class="small">LOBAL</span> C<span class="small">ITY</span><a id="page_20"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?d5ac71b6